module.exports = __webpack_public_path__ + "img/workflow_5.4083e651.jpg";